import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { isInputEmpty } from 'apps/t2c-fe/utils';

const urlPattern = /^(https?:\/\/www\.)/;

export const useContentGenerationForm = () => {
  const FormSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .typeError('Name must be a valid string')
      .test('not-empty', 'Name is required', (value) => !isInputEmpty(value)),
    url: Yup.string()
      .required('URL is required')
      .matches(urlPattern, 'URL must be a valid URL')
      .typeError('URL must be a valid string'),
  });

  const formMethods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: { url: '', name: '' },
    mode: 'onChange',
  });

  return formMethods;
};
